import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {ErrorMessage, expireError, Severity} from "./errors";
import {Alert, AlertColor, Box, Snackbar} from "@mui/material";


function severity2Style(severity: Severity|undefined): AlertColor {
    switch (severity) {
        case Severity.Info:
            return "info";
        case Severity.Success:
            return "success";
        case Severity.Warning:
            return "warning";
        default:
            return "error"
    }
}

export default () => {

    const errors = useSelector<RootState, ErrorMessage[]>((state) => state.errors.messages)
    const dispatch = useDispatch();
    return <Snackbar open autoHideDuration={null}>
        <Box>
            {errors.map((e, i) => <Alert key={i}
                                         onClose={() => dispatch(expireError(i))}
                                         severity={severity2Style(e.severity)}
                                         sx={{width: '100%', mt: 1}}>
                {e.message}
            </Alert>)}
        </Box>
    </Snackbar>;

}